export default {
  path: '/forgot_passwords',
  name: 'forgot_passwords',
  component: () => import('../components/forgotpassword/Layout'),
  redirect: { name: 'ForgotPasswordList' },
  meta: {
    breadcrumb: 'administration.user.forgotpasswords',
  },
  children: [
    {
      name: 'ForgotPasswordList',
      path: '',
      component: () => import('../views/forgotpassword/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ForgotPasswordShow',
      path: ':id',
      component: () => import('../views/forgotpassword/Show'),
      meta: {
        breadcrumb: 'administration.user.forgotpassword',
      },
    }
  ]
};
